import { render, staticRenderFns } from "./UserManagement.vue?vue&type=template&id=0cdc13ba"
import script from "./UserManagement.vue?vue&type=script&lang=js"
export * from "./UserManagement.vue?vue&type=script&lang=js"
import style0 from "./UserManagement.vue?vue&type=style&index=0&id=0cdc13ba&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports